import React from "react";
import { createRoot } from "react-dom/client";
import "./utils/i18n";

import App from "./App";
import * as Sentry from "@sentry/react";
import { keycloakConfig } from "./providers/authProvider";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import { RefineSnackbarProvider } from "@refinedev/mui";
import { config } from "./config/config";

Sentry.init({
  dsn: "https://f66d244abdf52066307e1f2d0f166501@o4509848194449408.ingest.us.sentry.io/4509848607064064",
  enableLogs: true,
  sendDefaultPii: true,
  release: config.ENV,
});

const container = document.getElementById("root") as HTMLElement;
const root = createRoot(container);

root.render(
  <ReactKeycloakProvider authClient={keycloakConfig}>
    <React.StrictMode>
      <RefineSnackbarProvider>
        <App />
      </RefineSnackbarProvider>
    </React.StrictMode>
  </ReactKeycloakProvider>,
);
